<div class="table-container">
  <app-list-header
    [title]="title"
    [searchPlaceholder]="'priorities.search' | translate"
    [searchTerm]="searchTerm | async"
    (searchTermChange)="searchTerm.next($event); searchPriority()"
    (clearSearch)="clearFilter()"
    (addNewItem)="createPriority()"
  ></app-list-header>
  <table class="table">
    <thead>
      <tr>
        <th class="name-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let priority of filteredPriority | async"
        (click)="select(priority)"
        [class.selected]="priority === selectedPriority"
      >
        <td>{{ priority.value }}</td>
        <td>
          <span
            [style.background-color]="'#6495ED'"
            mat-icon-button
            class="reduced"
          >
            <mat-icon [style.color]="priority.color">error_circle</mat-icon>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
